export default __webpack_public_path__ + "static/media/banner-1.e32ad993.jpg";